exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "svg[data-v-679bf852] {\n  display: inline-block;\n  width: 40px;\n  height: 40px;\n  fill: #555;\n  vertical-align: middle;\n}\nsvg.orange[data-v-679bf852] {\n  fill: orange;\n}\nsvg.green[data-v-679bf852] {\n  fill: #17c286;\n}", ""]);

// exports
